'use client';
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import { useDeprecatedProps } from '../../hooks/use-deprecated-props.js';
import { TabHeaderInput } from './tab-header-input.component.js';
import { TabHeaderLabel } from './tab-header-label.component.js';

function _define_property(e, r, t) {
    return r in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: true,
        configurable: true,
        writable: true
    }) : e[r] = t, e;
}
function _object_spread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {}, o = Object.keys(t);
        "function" == typeof Object.getOwnPropertySymbols && (o = o.concat(Object.getOwnPropertySymbols(t).filter(function(e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
        }))), o.forEach(function(r) {
            _define_property(e, r, t[r]);
        });
    }
    return e;
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        t.push.apply(t, o);
    }
    return t;
}
function _object_spread_props(e, r) {
    return r = null != r ? r : {}, Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : ownKeys(Object(r)).forEach(function(t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
    }), e;
}
function _object_without_properties(e, r) {
    if (null == e) return {};
    var t, o, n = _object_without_properties_loose(e, r);
    if (Object.getOwnPropertySymbols) {
        var p = Object.getOwnPropertySymbols(e);
        for(o = 0; o < p.length; o++)t = p[o], !(r.indexOf(t) >= 0) && Object.prototype.propertyIsEnumerable.call(e, t) && (n[t] = e[t]);
    }
    return n;
}
function _object_without_properties_loose(e, r) {
    if (null == e) return {};
    var t, o, n = {}, p = Object.keys(e);
    for(o = 0; o < p.length; o++)t = p[o], r.indexOf(t) >= 0 || (n[t] = e[t]);
    return n;
}
const TabHeader = (i)=>{
    let { children: c, inputProps: s = {}, tabId: a, disabled: b = false } = i, u = _object_without_properties(i, [
        "children",
        "inputProps",
        "tabId",
        "disabled"
    ]);
    return useDeprecatedProps('TabHeader', i, [
        {
            propName: 'disabled',
            instructions: 'Disabled tabs are discouraged and will be removed in a future version of SWAN. Please avoid using this prop.'
        }
    ]), jsxs(Fragment, {
        children: [
            jsx(TabHeaderInput, _object_spread({
                tabId: a,
                disabled: !!b
            }, s)),
            jsx(TabHeaderLabel, _object_spread_props(_object_spread({
                tabId: a
            }, u), {
                children: c
            }))
        ]
    });
};

export { TabHeader };
